import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Match } from '../../../models';

@Component({
  selector: 'matches-list-view',
  templateUrl: './matches-list-view.html'
})
export class MatchesListViewComponent {
  @Input() matches: Match[];

  @Output() readonly delete = new EventEmitter<Match>();
  @Output() readonly edit = new EventEmitter<Match>();
  @Output() readonly import = new EventEmitter<Match>();
  @Output() readonly export = new EventEmitter<Match>();

  onDelete(match: Match) {
    this.delete.emit(match);
  }

  onEdit(match: Match) {
    this.edit.emit(match);
  }
  
  onExport(match: Match) {
    this.export.emit(match);
  }

  onImport(match: Match) {
    this.import.emit(match);
  }
}
